import { render, staticRenderFns } from "./SingleClass.vue?vue&type=template&id=1e4f5254&scoped=true&"
import script from "./SingleClass.vue?vue&type=script&lang=js&"
export * from "./SingleClass.vue?vue&type=script&lang=js&"
import style0 from "./SingleClass.vue?vue&type=style&index=0&id=1e4f5254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4f5254",
  null
  
)

export default component.exports